import { IconAlertCircle } from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon, Typography } from '@rossum/ui/material';
import { FormattedMessage } from 'react-intl';

type Props = {
  schemaConceptExists: boolean;
};

const SchemaAlert = ({ schemaConceptExists }: Props) => (
  <Stack height={1} justifyContent="center" alignItems="center" spacing={1}>
    <SvgIcon fontSize="large" color="action">
      <IconAlertCircle />
    </SvgIcon>
    <Typography>
      <FormattedMessage id="containers.queueSchema.components.schemaAlert" />
    </Typography>
    <Typography variant="body2" color="text.secondary">
      <FormattedMessage
        id={`containers.queueSchema.components.schemaAlert.${
          schemaConceptExists ? 'jsonError' : 'start'
        }`}
      />
    </Typography>
  </Stack>
);

export default SchemaAlert;
